import React, { Component } from 'react';

export default class ClassName extends Component {
    render() {
        return (
            <section>
                <p>Inventory here</p>
            </section>
        )
    }
}

